enum ReportStatus {
  None,
  Draft,
  Deleted,
  Completed
}

export default ReportStatus